var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4644",
    "data-name": "Rectangle 4644",
    width: 10,
    height: 10,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_186",
    "data-name": "Mask Group 186",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_",
    transform: "translate(0.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M8.554,4.2A3.024,3.024,0,0,0,5.877,1.315l-.1-.015a1.391,1.391,0,0,0-.227-.025.381.381,0,0,0-.408.342.4.4,0,0,0,.059.31.586.586,0,0,0,.421.181c.042.006.081.011.114.019A2.133,2.133,0,0,1,7.749,4.222c.005.032.008.072.01.115.01.158.03.488.384.488h0a.629.629,0,0,0,.094-.008c.33-.05.32-.351.315-.5a.735.735,0,0,1,0-.1A.141.141,0,0,0,8.554,4.2Z",
    transform: "translate(-0.131)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M5.468.8c.04,0,.077.006.108.01A3.616,3.616,0,0,1,9.061,4.4a1.293,1.293,0,0,1,.006.132c0,.173.009.532.395.54h.012a.379.379,0,0,0,.286-.109A.6.6,0,0,0,9.866,4.5c0-.037,0-.072,0-.1A4.474,4.474,0,0,0,5.671.006H5.617c-.023,0-.05,0-.08,0S5.462,0,5.421,0a.4.4,0,0,0-.437.408C4.963.761,5.3.786,5.468.8Z",
    transform: "translate(-0.131)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M8.955,7.258c-.047-.036-.095-.073-.14-.109-.24-.193-.495-.371-.741-.543L7.92,6.5a1.53,1.53,0,0,0-.868-.33,1.125,1.125,0,0,0-.937.593.5.5,0,0,1-.427.259.848.848,0,0,1-.344-.086A4.141,4.141,0,0,1,3.18,4.829c-.2-.452-.136-.748.218-.989a1,1,0,0,0,.549-.877A5.01,5.01,0,0,0,2.184.558a1,1,0,0,0-.681,0A1.97,1.97,0,0,0,.278,1.565,1.874,1.874,0,0,0,.3,3.078,12.206,12.206,0,0,0,2.983,7.155a12.983,12.983,0,0,0,4.063,2.7,2.25,2.25,0,0,0,.4.119l.093.022A.156.156,0,0,0,7.58,10h.013A2.305,2.305,0,0,0,9.507,8.543C9.748,7.864,9.308,7.528,8.955,7.258Z",
    transform: "translate(-0.131)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M5.8,2.6a.462.462,0,0,0-.486.28.375.375,0,0,0,.016.326A.488.488,0,0,0,5.7,3.4a.87.87,0,0,1,.808.87.411.411,0,0,0,.392.406h0l.046,0c.249-.03.369-.212.358-.543a1.551,1.551,0,0,0-.484-1.049A1.444,1.444,0,0,0,5.8,2.6Z",
    transform: "translate(-0.131)",
    fill: "#8e8e8e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1db173cfc6f9cb820152978089899008.svg";
export { ForwardRef as ReactComponent };